var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG3093(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2631_1886",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 0H24.667V24H0.666992V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2631_1886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6982 11.999C19.6982 15.8823 16.5503 19.0303 12.667 19.0303C8.78373 19.0303 5.63574 15.8823 5.63574 11.999C5.63574 8.11576 8.78373 4.96777 12.667 4.96777C16.5503 4.96777 19.6982 8.11576 19.6982 11.999Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1831 9.8916L11.9644 14.1104L9.15186 11.2979",
    stroke: "#2CAC4C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7551 1.03789C12.2806 0.590236 13.0533 0.590236 13.5789 1.03789L15.4062 2.65063L18.4985 2.41133C19.1868 2.35808 19.812 2.81225 19.974 3.48331L20.594 6.05094L23.2958 7.66822C23.8839 8.02972 24.1227 8.76463 23.8594 9.40274L22.792 11.9892L23.8594 14.5756C24.1227 15.2137 23.8839 15.9486 23.2958 16.3101L20.594 17.9274L19.974 20.495C19.812 21.1661 19.1868 21.6203 18.4985 21.567L15.4365 21.33L13.5789 22.9602C13.0533 23.4078 12.2806 23.4078 11.7551 22.9602L9.89752 21.33L6.83546 21.567C6.14715 21.6203 5.52198 21.1661 5.35998 20.495L4.73752 17.9173L2.04024 16.3101C1.45205 15.9486 1.21327 15.2137 1.47666 14.5756L2.54401 11.9892L1.47666 9.40274C1.21327 8.76463 1.45205 8.02972 2.04024 7.66822L4.50634 6.20314L5.35998 3.48331C5.52198 2.81225 6.14715 2.35808 6.83546 2.41133L9.92781 2.65063L11.7551 1.03789Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG3093);
export default __webpack_public_path__ + "static/media/g3093.193bd10e11f7f0e95d91a8c7bab39b2d.svg";
export { ForwardRef as ReactComponent };